module.exports = require("vuetify/lib/components/VCheckbox");